import { buildOrganizationWebfontsFromSchema } from '../components/Fonts/helper';
import { GoogleFontsService } from '../Services/GoogleFonts/GoogleFontsService';
import { OrganizationFontsSchema } from '../definitions/schemas';
import SnackbarStore from '../stores/observables/SnackbarStore';
import { formatUrl } from './String';
import OrganizationsStore from '../stores/observables/OrganizationsStore';

export const MINDTICKLE_PRIVACY_POLICY =
  'https://www.mindtickle.com/privacy-policy/';

export const AUTO_ROOM_CREATION_ARTICLE =
  'https://help.mindtickle.com/support/solutions/articles/3000130373-automatically-create-rooms-for-salesforce-opportunities-in-dsr';

export const MINDTICKLE_SUBPROCESSOR_REPOSITORY =
  'https://www.mindtickle.com/sub-processor-repository';

/**
 * Convenience method to use the GoogleFontsService to fetch the fonts
 * defined for the organization, load their CSS font-face definition and
 * attach them as a stylesheet. This also catches any error to avoid promise
 * rejection, in order to default to the app's default font (Inter) and
 * continue to load the page without issues
 */
export const loadOrganizationFonts = (
  fonts: OrganizationFontsSchema | undefined
) => {
  if (!fonts) {
    return Promise.resolve(undefined);
  }

  const fontsToLoad = buildOrganizationWebfontsFromSchema(fonts);

  try {
    return new GoogleFontsService().loadFonts(fontsToLoad);
  } catch (e) {
    SnackbarStore.show(`Couldn't fetch fonts: ${e}`);
    return Promise.resolve(undefined);
  }
};

/**
 * Returns the current organization's privacy policy, which could be
 * one of the following scenarios:
 *   1. If the org has a custom privacy policy, use that
 *   2. Fallback to the vendor's privacy policy
 *   3. As the last resort, use the Enable Us' privacy policy
 */
export const getPrivacyPolicy = (): string => {
  const org = OrganizationsStore.getCurrentOrganization();

  const privacyPolicy =
    org?.privacyPolicyLink || org?.vendor?.privacyPolicyLink;

  return formatUrl(privacyPolicy?.trim() || MINDTICKLE_PRIVACY_POLICY);
};
